
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';          

@Injectable({
  providedIn: 'root'
})
export class SessionItemsService {           
  private apiUrl = '/TgNewUI/Search/Ajax/GetSessionItems';
  constructor(private http: HttpClient) {}
  fetchSessionItems(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload).pipe(tap((response) => {}));
  }
}